<template>
  <section class="ticket-checklist-panel">
    <header><strong>Checklist</strong><span>{{ subtitle }}</span></header>
    <div class="ticket-checklist-panel__content">
      <div class="ticket-checklist__progress" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
        <span :style="{ width: `${progress}%` }"></span>
      </div>
      <draggable :list="items" handle=".ticket-checklist__handle" :disabled="readonly" @end="$emit('reorder')">
        <div v-for="item in items" :key="item.id" class="ticket-checklist__item">
          <button v-if="!readonly" type="button" class="ticket-checklist__handle" aria-label="Reorder checklist item">⋮⋮</button>
          <app-checkbox :value="item.completed" design="new" :label="item.text" :disabled="readonly" @change="$emit('toggle', item, $event)" />
          <button v-if="!readonly" type="button" class="ticket-checklist__delete" :aria-label="`Delete ${item.text}`" @click="$emit('remove', item)">×</button>
        </div>
      </draggable>
      <div v-if="!readonly" class="ticket-checklist__new">
        <app-input :value="newItem" design="new" placeholder="Add a follow-up step" @input="$emit('update:new-item', $event)" @keyup.enter.native="$emit('add')" />
        <app-button design="new" size="small" :disabled="!newItem || working" @click.native="$emit('add')">Add</app-button>
      </div>
    </div>
  </section>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'SupportTicketChecklistPanel',
  components: { draggable },
  props: {
    items: { type: Array, required: true },
    newItem: { type: String, default: '' },
    working: Boolean,
    readonly: Boolean
  },
  computed: {
    completedCount() { return this.items.filter(item => item.completed).length },
    subtitle() { return `${this.completedCount}/${this.items.length} completed` },
    progress() { return this.items.length ? Math.round((this.completedCount / this.items.length) * 100) : 0 }
  }
}
</script>

<style lang="scss" scoped>
.ticket-checklist-panel { min-width: 0; padding: 20px; border: 1px solid $ui-line; border-radius: 16px; background: $ui-surface; box-shadow: 0 8px 26px rgba(28, 45, 74, .055); }
.ticket-checklist-panel > header { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ticket-checklist-panel > header strong { color: $ui-ink; font-family: $ui-font-heading; font-size: 16px; font-weight: 600; }
.ticket-checklist-panel > header span { color: $ui-muted; font-size: 14px; }
.ticket-checklist-panel__content { display: flex; flex-direction: column; gap: 12px; margin-top: 14px; }
.ticket-checklist__item { display: grid; min-height: 38px; grid-template-columns: 26px minmax(0, 1fr) 24px; align-items: center; gap: $ui-space-4; }
.ticket-checklist__progress { height: 7px; margin: 0 0 $ui-space-12; overflow: hidden; border-radius: 999px; background: rgba($ui-green, .16); }
.ticket-checklist__progress span { display: block; height: 100%; border-radius: inherit; background: $ui-green; transition: width .2s ease; }
.ticket-checklist__handle,
.ticket-checklist__delete { border: 0; background: transparent; color: $ui-muted; cursor: grab; }
.ticket-checklist__delete { color: $ui-red; cursor: pointer; font-size: 18px; }
.ticket-checklist__new { display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: $ui-space-8; margin-top: $ui-space-12; }
</style>
